import {useI18n} from 'i18n/I18nContext'
import moment from 'moment'
import {useOrganizationInvoices} from 'organization/Invoices/Invoices/OrganizationInvoicesProvider'
import React from 'react'
import styled from 'styled-components'
import {publicUrl} from 'utils/lib/url'

export default function OrganizationInvoices() {
  const {t} = useI18n()
  const {invoices} = useOrganizationInvoices()

  return (
    <div className="col-12">
      <div className="create__event-area">
        <div className="body__card-wrapper attendant__wrapper">
          <table>
            <thead>
              <tr>
                <th>{t('orgInvoiceTx.thNumber')}</th>
                <th>{t('orgInvoicesList.thType')}</th>
                <th>{t('orgInvoiceTx.thDate')}</th>
                <th>{t('orgInvoicesList.thVat')}</th>
                <th>{t('orgInvoicesList.thTotal')}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {invoices.length === 0 && (
                <tr>
                  <td colSpan={6}>{t('orgInvoicesList.empty')}</td>
                </tr>
              )}
              {invoices &&
                invoices.map((invoice) => {
                  return (
                    <tr key={invoice.id}>
                      <td>
                        <div className="attendant__serial">
                          <span> #{invoice.number}</span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <span>
                            {invoice.type === 'in'
                              ? t('orgInvoicesList.typeOutgoing')
                              : t('orgInvoicesList.typeIncoming')}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div className="attendant__date">
                          <span>
                            {moment(invoice.issued_at).format(
                              'DD.MM.YYYY HH:mm',
                            )}{' '}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <span> {(invoice.vat / 100).toFixed(2)} €</span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <span> {(invoice.total / 100).toFixed(2)} €</span>
                        </div>
                      </td>

                      <td>
                        <div>
                          <a href={publicUrl(invoice?.pdf_path)} download>
                            <PrimaryButton>
                              {t('orgInvoicesList.download')}
                            </PrimaryButton>
                          </a>
                        </div>
                      </td>
                    </tr>
                  )
                })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
`

export const SectionTitle = styled.h3`
  margin: 0;
`

export const SectionCard = styled.div`
  background: #fff;
  border: 1px solid #eee;
  padding: 16px;
`

export const PrimaryButton = styled.button`
  border: none;
  border-radius: 10px;
  padding: 10px 12px;
  background: linear-gradient(91deg, #f7426f 5.15%, #f87a58 99.88%);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const CompanyName = styled.div`
  font-weight: 800;
  margin-bottom: 8px;
`

export const CompanyLine = styled.div`
  margin: 4px 0;
  color: #333;
`

export const CompanyCard = styled.div`
  border: 1px solid #eee;
  border-radius: 14px;
  padding: 14px;
  background: #fafafa;
`

export const CardActions = styled.div`
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1rem;
`

export const SecondaryButton = styled.button`
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  padding: 10px 12px;
  background: #fff;
  color: #111;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 3.5rem 0;
  font-size: 1.1rem;
  color: ${({theme}) => theme?.colors?.textSecondary || '#777'};
`
